export const MIXPAY_ORDER_STATUS = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  PENDING_VERIFY: 'PENDING_VERIFY',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  EXPIRED: 'EXPIRED',
};

export const MIXPAY_ORDER_POLL_MS = 2_000;
export const MIXPAY_ORDER_POLL_MAX_MS = 180_000;

export function isMixPayLedgerCredited(order) {
  return order?.ledgerCredited === true;
}

export function normalizeMixPayOrdersPage(data) {
  const rows = Array.isArray(data?.rows)
    ? data.rows
    : Array.isArray(data?.data?.rows)
    ? data.data.rows
    : Array.isArray(data)
    ? data
    : [];
  const total = Number(data?.total ?? data?.data?.total ?? rows.length) || 0;
  return { rows, total };
}

export function normalizeMixPayOrderStatus(status) {
  return String(status ?? '')
    .trim()
    .toUpperCase();
}

export function extractMixPayOrderId(order) {
  return String(
    order?.merchantOrderNo ?? order?.orderNo ?? order?.orderId ?? order?.id ?? ''
  ).trim();
}

export function findMixPayOrderById(orders, orderId) {
  const list = Array.isArray(orders) ? orders : [];
  const target = String(orderId ?? '')
    .trim()
    .toLowerCase();
  if (!target || !list.length) return null;
  return list.find((row) => extractMixPayOrderId(row).toLowerCase() === target) || null;
}

/** @returns {'pending'|'success'|'failed'|'neutral'} */
export function resolveMixPayReturnPhase(
  status,
  { timedOut = false, ledgerCredited = false, order = null } = {}
) {
  const s = normalizeMixPayOrderStatus(status);
  const credited = ledgerCredited || isMixPayLedgerCredited(order);
  if (s === MIXPAY_ORDER_STATUS.SUCCESS) {
    return credited ? 'success' : 'pending';
  }
  if (s === MIXPAY_ORDER_STATUS.FAILED || s === MIXPAY_ORDER_STATUS.EXPIRED) return 'failed';
  if (timedOut) return 'neutral';
  return 'pending';
}

export function isMixPayReturnTerminalPhase(phase) {
  return phase === 'success' || phase === 'failed' || phase === 'neutral';
}
